// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "backButton__wrapper-339zR";
var _3 = "toolbar__backButton-zX-jj";
export { _1 as "__esModule", _2 as "backButton__wrapper", _3 as "toolbar__backButton" }
export default { "__esModule": _1, "backButton__wrapper": _2, "toolbar__backButton": _3 }
